<template>
  <div>
    <div v-wechat-title="'《最强蜗牛》双旦奇妙夜'"></div>
    <div class="pc-page">
      <div class="logo"></div>
      <div class="banner">
        <div class="part-banner"></div>
      </div>
      <div class="qrcode-box"></div>
    </div>
  </div>

</template>
<script>
import { getTimeStamp , buriedLogger } from '@/utils/utils';
import { mapActions } from 'vuex';
export default {
  components: {},
  data () {
    return {
      enterLink: '',
    };
  },
  created () {
    const bl = buriedLogger("snail", "最强蜗牛_双旦活动_PC端");
    this.logger = bl;
  },
  mounted () {
    this.$nextTick(() => {
      // 分享
      this.enterLink = 'https://h5.qingcigame.com/snail/doubleFestival/enter';
      this.monitoringEquipment(this.enterLink);
      this.isSetShare(this.enterLink);
    });
  },
  computed: {},
  methods: {
    monitoringEquipment(linkUrl) {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = `${linkUrl}${getTimeStamp()}`
      }
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '【最强蜗牛】听蜗的当个事儿办！',
        imgUrl: "https://download4.qcplay.com/qcgame-api/NYua9swVA6CmIfnxLMTRGHEuTsog5ZIvNc8yNoSV.png",
        desc: "加入寻宝小队，开启Beter宝库，领取限定绿贵就像呼吸一样简单，还有百年VIP卡限时抽取，入队速戳！",
      })
    },
    ...mapActions(["setShare"])
  }
};
</script>

<style lang="less" scoped>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/doubleFestival/pc/index.vue